"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _GLTFLoader = require("three/examples/jsm/loaders/GLTFLoader");
var THREE = _interopRequireWildcard(require("three"));
var _gsap = _interopRequireDefault(require("gsap"));
var _DRACOLoader = require("three/examples/jsm/loaders/DRACOLoader");
var _eventHub = _interopRequireDefault(require("@/utils/eventHub"));
var _camera = _interopRequireDefault(require("../camera"));
var _CSS3DRenderer = require("three/examples/jsm/renderers/CSS3DRenderer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var City = exports.default = /*#__PURE__*/function () {
  function City(scene) {
    var _this = this;
    (0, _classCallCheck2.default)(this, City);
    // 载入模型
    this.scene = scene;
    this.loader = new _GLTFLoader.GLTFLoader();
    var dracoLoader = new _DRACOLoader.DRACOLoader();
    dracoLoader.setDecoderPath("./draco/");
    this.loader.setDRACOLoader(dracoLoader);
    this.loader.load("./model/tianjia.glb", function (gltf) {
      // 放大模型
      var scaleFactor = 8;
      gltf.scene.scale.set(scaleFactor, scaleFactor, scaleFactor);
      // 旋转模型至正面
      gltf.scene.rotation.set(0, Math.PI / 1.3, 0);
      scene.add(gltf.scene);
      gltf.scene.traverse(function (child) {
        if (child.isMesh) {
          child.material.emissiveIntensity = 5;
        }
        if (child.name === "平面") {
          // 加载纹理
          var textureLoader = new THREE.TextureLoader();
          var texture = textureLoader.load("./textures/bg.jpg", function () {
            // 设置纹理重复
            texture.wrapS = THREE.RepeatWrapping;
            texture.wrapT = THREE.RepeatWrapping;
            texture.repeat.set(64, 64); // 设置重复次数，可以根据需要调整

            // 创建材质
            var planeMaterial = new THREE.MeshStandardMaterial({
              color: 0x808080,
              map: texture,
              side: THREE.DoubleSide
            });

            // 应用材质
            child.material = planeMaterial;
          });
        }
        if (child.name.indexOf("深蓝色") > 0) {
          console.log(child.name);
          // 克隆现有的材质
          var material = child.material.clone();
          // 设置新的颜色
          material.color.set(0x28539a);
          // 设置自发光颜色和强度
          // material.emissive.set(0x00ffff); // 明亮的蓝色
          // material.emissiveIntensity = 1.0; // 自发光强度可以根据需要调整
          // 将新的材质应用到子对象
          child.material = material;
        }
        if (child.name.startsWith("主机#") || child.name.startsWith("DFW泵") || child.name.startsWith("余热回收机") || child.name.startsWith("组合柜")) {
          if (child.name.lastIndexOf("#") > 0) {
            var num = child.name.substring(child.name.lastIndexOf("#") + 1, child.name.length);
            if (num % 2 === 0) {
              _this.createTagRight(child);
            } else {
              _this.createTag(child);
            }
          } else {
            _this.createTag(child);
          }
        }
        if (child.name.startsWith("温度计")) {
          _this.createWdTag(child);
        }
      });
      // 计算模型的边界框
      var box = new THREE.Box3().setFromObject(gltf.scene);
      var center = box.getCenter(new THREE.Vector3());
    });
  }
  return (0, _createClass2.default)(City, [{
    key: "createTag",
    value: function createTag(object3d) {
      var element = document.createElement("div");
      element.className = "elementTag";
      element.innerHTML = "\n      <div class=\"elementContent\">\n       <p>".concat(object3d.name, "</p>\n        <p>\u6E29\u5EA6\uFF1A26\xB0</p>\n        <p>\u5F00\u5173\u72B6\u6001\uFF1AON</p>\n      </div>\n    ");
      var objectCSS3D = new _CSS3DRenderer.CSS3DObject(element);
      objectCSS3D.scale.set(0.2, 0.2, 0.2);
      // 获取 object3d 的世界坐标
      var worldPosition = new THREE.Vector3();
      object3d.getWorldPosition(worldPosition);
      objectCSS3D.position.copy(worldPosition);
      objectCSS3D.rotation.set(0, 45 * Math.PI / 180, 0);
      this.scene.add(objectCSS3D);
    }
  }, {
    key: "createTagRight",
    value: function createTagRight(object3d) {
      var element = document.createElement("div");
      element.className = "elementTagRight";
      element.innerHTML = "\n      <div class=\"elementContentRight\">\n        <p>".concat(object3d.name, "</p>\n        <p>\u6E29\u5EA6\uFF1A26\xB0</p>\n         <p>\u5F00\u5173\u72B6\u6001\uFF1AON</p>\n      </div>\n    ");
      var objectCSS3D = new _CSS3DRenderer.CSS3DObject(element);
      objectCSS3D.scale.set(0.2, 0.2, 0.2);
      // 获取 object3d 的世界坐标
      var worldPosition = new THREE.Vector3();
      object3d.getWorldPosition(worldPosition);
      objectCSS3D.position.copy(worldPosition);
      objectCSS3D.rotation.set(0, 45 * Math.PI / 180, 0);
      this.scene.add(objectCSS3D);
    }
  }, {
    key: "createWdTag",
    value: function createWdTag(object3d) {
      var element = document.createElement("div");
      element.className = "elementTagWd";
      element.innerHTML = "\n      <div class=\"elementContentWd\">\n        <p>".concat(object3d.name, "</p>\n        <p>\u6E29\u5EA6\uFF1A26\xB0</p>\n      </div>\n    ");
      var objectCSS3D = new _CSS3DRenderer.CSS3DObject(element);
      objectCSS3D.scale.set(0.2, 0.2, 0.2);
      // 获取 object3d 的世界坐标
      var worldPosition = new THREE.Vector3();
      object3d.getWorldPosition(worldPosition);
      objectCSS3D.position.copy(worldPosition);
      objectCSS3D.rotation.set(0, 45 * Math.PI / 180, 0);
      this.scene.add(objectCSS3D);
    }
  }]);
}();